import styled from 'styled-components';

export const StatCardRowContainer = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.Tablet}) {
    flex-wrap: wrap;
  }
`;

export const StatCardItem = styled.div<{ $fullWidth?: boolean }>`
  flex: 1;
  min-width: 0;
  max-width: ${({ $fullWidth }) => ($fullWidth ? 'none' : 'calc(25% - 12px)')};

  @media (max-width: ${({ theme }) => theme.breakpoints.Tablet}) {
    min-width: calc(50% - 16px);
    max-width: none;
  }
`;
